import { Price } from '@virginexperiencedays/products';

export const MULTIPLE_BRAND = 'Multiple Suppliers';

export const getDimension6 = ({
  price: { percentOff, fixedAmountOff } = { percentOff: null, fixedAmountOff: null } as Price,
}: {
  price: Price;
}) => (percentOff ? `${percentOff}% OFF` : null) ?? (fixedAmountOff ? `£${fixedAmountOff}` : null);

export const getSingleSupplierName = (
  suppliers: { name: string }[],
  isCollectionProduct?: boolean
) => {
  const singleSupplier = suppliers?.length > 1 ? MULTIPLE_BRAND : suppliers?.[0]?.name ?? '';
  if (isCollectionProduct) return singleSupplier || MULTIPLE_BRAND;
  return singleSupplier;
};
